import { telemetryIncrementAction } from 'core-events/actions';

export function shouldTrack(eventType: 'click' | 'impression', telemetryEvents?: ('click' | 'impression')[]): boolean {
    return telemetryEvents === undefined || telemetryEvents.includes(eventType);
}

export function telemetryClickHandler(
    telemetrySlug?: string,
    telemetryEvents?: ('click' | 'impression')[],
): (() => void) | undefined {
    return telemetrySlug && shouldTrack('click', telemetryEvents)
        ? () => void telemetryIncrementAction(`${telemetrySlug}.click`)
        : undefined;
}

export function telemetryImpressionHandler(telemetrySlug?: string, telemetryEvents?: ('click' | 'impression')[]): void {
    if (telemetrySlug && shouldTrack('impression', telemetryEvents)) {
        void telemetryIncrementAction(`${telemetrySlug}.impression`);
    }
}
